import { render, staticRenderFns } from "./CruisePortsPopup.vue?vue&type=template&id=b87153f4&scoped=true"
import script from "./CruisePortsPopup.vue?vue&type=script&lang=js"
export * from "./CruisePortsPopup.vue?vue&type=script&lang=js"
import style0 from "./CruisePortsPopup.vue?vue&type=style&index=0&id=b87153f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87153f4",
  null
  
)

export default component.exports